module.exports = __webpack_public_path__ + "static/img/page3-bg.4feb9ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page3-bg.png
// module id = AYdl
// module chunks = 216